/** Partner (affiliate) link builders. Every link opens in the external browser and is labelled as a partner link. */
const TP_MARKER = process.env.REACT_APP_TP_MARKER;
const CJ_BOOKING = process.env.REACT_APP_CJ_BOOKING_LINK;
const TP_GYG_P = process.env.REACT_APP_TP_GYG_P;
const TP_TIQETS_P = process.env.REACT_APP_TP_TIQETS_P;
const GYG_PARTNER = process.env.REACT_APP_GYG_PARTNER_ID;

const tp = (p, url) => (TP_MARKER && p ? `https://tp.media/r?marker=${TP_MARKER}&trs=mondearabe&p=${p}&u=${encodeURIComponent(url)}` : url);

export const hasMarker = () => Boolean(TP_MARKER);

export function bookingLink(city, { lang = "en", currency = "EUR" } = {}) {
  const url = `https://www.booking.com/searchresults.html?ss=${encodeURIComponent(city)}&lang=${lang}&selected_currency=${currency}`;
  return CJ_BOOKING ? `${CJ_BOOKING}?url=${encodeURIComponent(url)}` : url;
}

export function hotellookLink(city, { lang = "en", currency = "EUR" } = {}) {
  const u = new URLSearchParams({ destination: city, language: lang, currency: currency.toLowerCase() });
  if (TP_MARKER) u.set("marker", TP_MARKER);
  return `https://search.hotellook.com/?${u}`;
}

export function flightsLink(originIata, destIata, { lang = "en", currency = "EUR" } = {}) {
  const u = new URLSearchParams({ destination_iata: destIata, locale: lang, currency: currency.toLowerCase() });
  if (originIata) u.set("origin_iata", originIata);
  if (TP_MARKER) u.set("marker", TP_MARKER);
  return `https://www.aviasales.com/?${u}`;
}

export function toursLink(query, { lang = "en" } = {}) {
  const base = `https://www.getyourguide.com/s/?q=${encodeURIComponent(query)}&lc=${lang}${GYG_PARTNER ? `&partner_id=${GYG_PARTNER}` : ""}`;
  return tp(TP_GYG_P, base);
}

export function ticketsLink(query, { lang = "en" } = {}) {
  return tp(TP_TIQETS_P, `https://www.tiqets.com/${lang}/search?q=${encodeURIComponent(query)}`);
}
